import axios from 'axios';
import {
  AUTH_COOKIE_MODE,
  clearAuthTokens,
  getAccessToken,
  getRefreshTokenBody,
  persistAuthTokens,
} from './authTokens';

const api = axios.create({
  baseURL: '/api/v1',
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const token = getAccessToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

let refreshPromise = null;

async function refreshAccessToken() {
  const body = getRefreshTokenBody();
  // Cookie mode: empty body; browser sends httpOnly refresh cookie via withCredentials
  if (!AUTH_COOKIE_MODE && !body.refreshToken) {
    throw new Error('No refresh token');
  }
  const { data } = await axios.post('/api/v1/auth/refresh', body, { withCredentials: true });
  persistAuthTokens(data);
  return data.accessToken;
}

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const original = error.config;
    if (
      error.response?.status === 401
      && error.response?.data?.code === 'TOKEN_EXPIRED'
      && original
      && !original._dfRetry
    ) {
      original._dfRetry = true;
      try {
        if (!refreshPromise) {
          refreshPromise = refreshAccessToken().finally(() => { refreshPromise = null; });
        }
        const accessToken = await refreshPromise;
        original.headers.Authorization = `Bearer ${accessToken}`;
        return api(original);
      } catch (_) {
        clearAuthTokens();
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  },
);

export default api;
